export const COMMON_CONSTANTS = {
    VerifyMobileNumber : "VerifyMobileNumber" , 
    DigitalKyc : "DigitalKyc",
    VerifySim : "VerifySim",
    ThankYou : "ThankYou",
    ThankYouFailure : "ThankYouFailure",
    StartSubmit : "StartSubmit",
    OtpAdhaarModal  : "OtpAdhaarModal",
    OtpModalStart  : "OtpModalStart",
    OtpModalReferre  : "OtpModalReferre",
    FinalOtpModal  : "FinalOtpModal",
    KycSubmitStep1 : "KycSubmitStep1",
    SubmitStep1 : "SubmitStep1",
    PlanSelection  : "PlanSelection",
    SubmitStep2 : "SubmitStep2",
    NumberSelection  : "NumberSelection",
    IdVerification  : "IdVerification",
    CheckBoxModal  : "CheckBoxModal",
    OtherDetails  : "OtherDetails",
    PersonalDetails  : "PersonalDetails",
    LocalReference  : "LocalReference",
    PhotoVerification  : "PhotoVerification",
    VideoCapture  : "VideoCapture",
    SubmitStep3  : "SubmitStep3",
    ThankYouAck : "ThankYouAck",
    ThankYouSteps : "ThankYouSteps",
    CustomerDeclaration : "CustomerDeclaration",
    SimDetails : "SimDetails",
    VerifyUpcCode : "VerifyUpcCode",
    CommonErrorModal : "CommonErrorModal",
    LocationFetch : "LocationFetch",

}

export const COMMON_SECTION_NAMES = Object.values(COMMON_CONSTANTS);
				